import { Box } from "@chakra-ui/react";
import { InputV2, SelectV2 } from "../../../Reusable";
import { Label } from "../../../Components/ui/label";
import { Input } from "../../../Components/ui/input";
import { Textarea } from "../../../Components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../Components/ui/select";

const StepOrganization = ({ formik }) => {
  return (
    <div className="space-y-4">
      {/* Organization Name */}
      <div className="space-y-2">
        <Label htmlFor="organization.name">Your Organization *</Label>
        <Input
          id="organization.name"
          placeholder="Your Organization"
          value={formik.values.organization?.name || ""}
          onChange={(e) =>
            formik.setFieldValue("organization.name", e.target.value)
          }
          required
        />
      </div>

      {/* Organization Type */}
      <div className="space-y-2">
        <Label htmlFor="organization.type">Select type *</Label>
        <Select
          value={formik.values.organization?.type || ""}
          onValueChange={(value) =>
            formik.setFieldValue("organization.type", value)
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Select type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="non-profit">Nonprofit</SelectItem>
            <SelectItem value="grassroots">Grassroots</SelectItem>
            <SelectItem value="foundation">Foundation</SelectItem>
            <SelectItem value="corporation">Corporation</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Location */}
      <div className="space-y-2">
        <Label htmlFor="organization.location">City, State/Country *</Label>
        <Input
          id="organization.location"
          placeholder="City, State/Country"
          value={formik.values.organization?.location || ""}
          onChange={(e) =>
            formik.setFieldValue("organization.location", e.target.value)
          }
          required
        />
      </div>

      {/* Mission Statement (Optional) */}
      <div className="space-y-2">
        <Label htmlFor="organization.mission">
          Brief description of your organization's mission
        </Label>
        <Textarea
          id="organization.mission"
          placeholder="Brief description of your organization's mission"
          rows={3}
          value={formik.values.organization?.mission || ""}
          onChange={(e) =>
            formik.setFieldValue("organization.mission", e.target.value)
          }
        />
      </div>
    </div>
  );
};

export default StepOrganization;

